import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/simulatieperinfrastructuur/";

const SimulatiePerInfrastructuurApi = {
	getByInfrastructuur(infrastructuurId) {
		const serviceUrl = prependRoot(routePrefix + infrastructuurId, getApiRoot());
		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	getByInfrastructuurWithForcedValidation(infrastructuurId) {
		const serviceUrl = prependRoot(routePrefix + infrastructuurId + "/validate", getApiRoot());
		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	getNewInfrastructuur() {
		const serviceUrl = prependRoot(routePrefix + "sportinfrastructuurindebuurt", getApiRoot());
		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	save(simulatiePerInfrastructuurModel) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return axios.put(serviceUrl, simulatiePerInfrastructuurModel,
			{
				headers: {
					'accept': 'application/json'
				}
			});
	},
	validateSimulatiePerInfrastructuur(simulatiePerInfrastructuur) {
		const serviceUrl = prependRoot(routePrefix + "validateSportInfrastructuurInDeBuurt", getApiRoot());
		return axios.put(serviceUrl, simulatiePerInfrastructuur, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default SimulatiePerInfrastructuurApi;
